import gql from 'graphql-tag';
import React from 'react';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { COUNTRY_CODES } from '../shared/constants';

const connect = gql`query TrendingSearchesQuery {
    trendingSearches(input: {
      nResults: 10,
    }) {
      trendingSearches {
        query
        categoryUuid
        categorySlug
      }
    }
  }`;

export default function withTrendingSearches<TProps extends {}>(
  Component: React.ComponentType<TProps>,
): React.ComponentType<TProps> {
  const requestConfig = {
    skip: ownProps => ownProps.user.countryCode !== COUNTRY_CODES.US,
    options: () => {
      return {
        ssr: false,
        variables: {},
      };
    },
    props({ data, ownProps }) {
      const { trendingSearches } = data;

      const props = {
        ...ownProps,
        trendingSearches: trendingSearches?.trendingSearches || [],
      };
      return props;
    },
  };
  return withGraphql(connect, requestConfig)(Component) as React.ComponentType<TProps>;
}
